function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
/*
    <ts-form-dirty-detector></ts-form-dirty-detector>

    Just add

          <ts-form-dirty-detector></ts-form-dirty-detector>

   anywhere inside a form.

    attributes:  disabled (optional) -  if present, don't do dirty detection. (Use JS to enable dirty detection if needed)

    properties: disabled - boolean; set/get disabled attribute
                dirty    - getter if the form is currently dirty

    TODO: remove dirty detection of the form/dirty-detector is being remioved form the DOM.

*/
var TsFormDirtyDetector = /*#__PURE__*/function (_HTMLElement) {
  function TsFormDirtyDetector() {
    _classCallCheck(this, TsFormDirtyDetector);
    return _callSuper(this, TsFormDirtyDetector, arguments);
  }
  _inherits(TsFormDirtyDetector, _HTMLElement);
  return _createClass(TsFormDirtyDetector, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.form = this.closest("form");
      this.form.dirty_detector = this; // so that we can find a form's dirty-detector quickly

      this._memorize();

      // seems like that the _window_global_unload_handler will only get registered once (good!)
      window.addEventListener('beforeunload', this._window_global_unload_handler);
    }
  }, {
    key: "disabled",
    get: function get() {
      return this.hasAttribute("disabled");
    },
    set: function set(_val) {
      if (this.disabled == _val) return;
      if (_val) {
        this.setAttribute("disabled", "");
      } else {
        this.removeAttribute("disabled");
      }
    }
  }, {
    key: "reset",
    value: function reset() {
      this._memorize();
    }
  }, {
    key: "dirty",
    get: function get() {
      var answer = false,
        current_nodelist = this._currentNodeList;
      if (current_nodelist.length != this.memorizedNodeList.length) {
        answer = true;
      } else {
        for (var j = current_nodelist.length; j > 0; j--) {
          var memorized_item = this.memorizedNodeList[j - 1],
            current_node = current_nodelist[j - 1];
          if (memorized_item.name != current_node.name || memorized_item.value != current_node.value) {
            answer = true;
            break;
          }
        }
      }
      return answer;
    }

    //
    //    Private
    //

    // a live nodelist
  }, {
    key: "_currentNodeList",
    get: function get() {
      return this.form.querySelectorAll("input, select, textarea");
    }
  }, {
    key: "_memorize",
    value: function _memorize() {
      this.memorizedNodeList = [].map.call(this._currentNodeList, function (i) {
        return {
          name: i.name,
          value: i.value
        };
      });
    }
  }, {
    key: "_window_global_unload_handler",
    value: function _window_global_unload_handler(e) {
      var msg = '';
      msg = [].reduce.call(document.querySelectorAll("ts-form-dirty-detector"), function (msg, detector) {
        return msg || !detector.disabled && detector.dirty;
      }, msg);
      if (msg) {
        e.returnValue = msg;
      }
      return msg;
    }
  }]);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
;
customElements.define('ts-form-dirty-detector', TsFormDirtyDetector);